import React, { useEffect, useState } from 'react';
import { defaultValues, State } from './types';
import { WithdrwalStage } from '../useWithdrawalStage';
import ConfirmMembershipPresenter from './ConfirmMembershipPresenter';
import { FormProvider, useForm } from 'react-hook-form';
import { useSnackbar } from '@components/Provider';
import WithdrawalConfirmDialog from '../WithdrawalConfirmDialog';
import {
  CapaErrorCode,
  CapaServiceType,
  CapaWithdrawClientReasonType,
  useWithdrawQuotationUserMutation
} from '@generated/graphql';
import getScopes from '@utils/getScopes';
import useClient from '@hooks/useClient';
import { apolloClient } from '@api/apollo';
import { PreventEditDialog } from '../../Dialog/RequestActionDialog';

interface Props {
  matches: boolean;
  isExistChatRooms: boolean;
  setStage: (stage: WithdrwalStage) => void;
  onChangeRoute: (path: string) => void;
}

const ConfirmMembershipContainer = ({
  matches,
  isExistChatRooms,
  setStage,
  onChangeRoute
}: Props) => {
  const { onInitClient } = useClient();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [preventModal, setPreventModal] = useState(false);

  const methods = useForm<State>({
    defaultValues: {
      ...defaultValues
    }
  });

  const { email } = getScopes();

  const { handleSubmit, errors } = methods;

  const [withdrawQuotationUser] = useWithdrawQuotationUserMutation();

  const onSubmit = handleSubmit((data) => {
    if (isExistChatRooms) {
      sessionStorage.setItem(
        'withdraw',
        JSON.stringify({
          reason: methods.getValues().reason,
          etcReason: methods.getValues().etcReason
        })
      );

      setStage('confirm-chat');
    } else {
      setOpen(true);
    }
  });

  const onWithdraw = async () => {
    await withdrawQuotationUser({
      variables: {
        input: {
          email: email,
          withdrawReason: {
            serviceType: CapaServiceType.Quotation,
            reason: methods.getValues().reason as CapaWithdrawClientReasonType,
            etcReason: methods.getValues().etcReason
          }
        }
      }
    }).then(({ data }) => {
      const result = data?.withdrawQuotationUser.result;

      if (result === CapaErrorCode.Success) {
        localStorage.clear();
        sessionStorage.clear();
        apolloClient.clearStore();
        onInitClient();

        return onChangeRoute('/mypage/withdrawal-complete');
      }
      if (result === CapaErrorCode.RfqPaymentInProgress) {
        setOpen(false);
        setPreventModal(true);
      }
    });
  };

  useEffect(() => {
    const keys = Object.keys(errors);

    const checklistError = keys.some((error) => error.includes('check'));

    const reasonError = keys.some((error) =>
      error.toLowerCase().includes('reason')
    );

    if (reasonError) {
      enqueueSnackbar('탈퇴 항목을 확인해주세요', { variant: 'error' });
      return window?.scrollTo({ 'top': 0 });
    } else if (checklistError) {
      const target = document.getElementById('check-list');

      return target?.scrollIntoView({ 'block': 'start' });
    } else {
      return;
    }
  }, [errors, enqueueSnackbar]);

  return (
    <FormProvider {...methods}>
      {open && (
        <WithdrawalConfirmDialog
          open
          onClose={() => setOpen(false)}
          matches={matches}
          onWithdraw={onWithdraw}
        />
      )}
      <PreventEditDialog
        open={preventModal}
        onClose={() => setPreventModal(false)}
        description={`캐파 회원 탈퇴신청이 불가능 합니다.\n파트너와 거래를 완료하거나 거래취소를 진행해주세요.`}
      />
      <ConfirmMembershipPresenter
        matches={matches}
        isExistChatRooms={isExistChatRooms}
        onSubmit={onSubmit}
        onChangeRoute={onChangeRoute}
      />
    </FormProvider>
  );
};

export default ConfirmMembershipContainer;
